const state = {
  application: {},
  selectedTiers: {},
  status: 0
};

const getters = {
  getApplication: state => state.application,
  getSelectedTiers: state => state.selectedTiers,
  getStatus: state => state.status
};

const mutations = {
  setApplication(state, application) {
    state.application = application;
  },
  setSelectedTiers(state, selectedTiers) {
    state.selectedTiers = selectedTiers;
  },
  setStatus(state, status) {
    state.status = status;
  }
};

const actions = {
  setStatus({ commit }, status) {
    commit("setStatus", status);
  },
  async setSelectedTiers({ commit }, payload) {
    commit("setSelectedTiers", payload);
  },
  async getApplication({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(
          `/api/v3/applications/${payload.application_id}`,
          {
            headers: {
              Authorization: `Bearer ${payload.token}`
            }
          }
        );
        commit("setApplication", res.data);

        // set the status of the application
        commit("setStatus", res.data.application_status_id);
        resolve(res.data);
      } catch (err) {
        reject(err);
      }
    });
  },
  async saveApplication({ commit }, payload) {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await axios.put(
          `/api/v3/applications/${payload.application_id}`,
          payload.body,
          {
            headers: {
              Authorization: `Bearer ${payload.token}`
            }
          }
        );
        commit("setApplication", res.data);

        // set the status of the application
        commit("setStatus", res.data.application_status_id);
        resolve(res.data);
      } catch (err) {
        reject(err);
      }
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
